export default __webpack_public_path__ + "static/media/36I-114292_-21038_0.5752ea23.jpg";